import { Fetch } from '@/utils/fetch';
import { clearToken, setToken } from '@/utils/token';
import { getPageQuery } from '@/utils/utils';
import { history } from '@umijs/max';
import { stringify } from 'qs';

export async function login(data: { email: string; password: string }) {
  const { token } = await Fetch.post<{
    token: string;
    username: string;
    email: string;
  }>('/s/auth/v1', {
    data,
    isPublic: true,
  });
  setToken({ token });
  return token;
}

export const loginOut = async () => {
  clearToken();
  const { redirect } = getPageQuery();
  if (window.location.pathname !== '/auth/login' && !redirect) {
    history.replace({
      pathname: '/auth/login',
      search: stringify({
        redirect: window.location.href,
      }),
    });
  }
};
